// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const NegativeRiskFactorsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path
      fill="currentColor"
      d="m10 10 1.76 1.76 6.99-6.97V20h2.5V4.79l6.98 6.99L30 10 20 0zM0 25l1.76 1.76 6.99-6.97V35h2.5V19.79l6.98 6.99L20 25 10 15zM20 25l1.76 1.76 6.99-6.97V35h2.5V19.79l6.98 6.99L40 25 30 15z"
    />
  </svg>,
  "NegativeRiskFactors",
);
export default NegativeRiskFactorsIcon;
